import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearBraintreeFailure } from '../modules/braintree_failure';
import { delayedClearFeedback, setFeedback } from '../modules/feedback';
import { setupHostedFields, setupPaypal, resetPaypalListener, braintreeObjCreate, braintreeObjDestroy } from '../shared/braintreeClientHelper';
import PayPalButton from './PayPalButton.jsx';
import TermsOfMembership from './CmsTermsOfMembership.jsx';


class NonClubBraintreeDropin extends Component {

  constructor(props) {
    super(props);
    this.oSelected = null;
    this.braintreeObj = null;
    this.newPayPalObj = null;
    this.state = {
      viewState : 'add',
      didBrainTreeSubmit: false,
      braintreeErrorObj:  null
    };

    this.viewNone             = this.viewNone.bind(this);
    this.viewSelected         = this.viewSelected.bind(this);
    this.viewSelectedHard     = this.viewSelectedHard.bind(this);
    this.viewAdd              = this.viewAdd.bind(this);
    this.braintreeRefresh     = this.braintreeRefresh.bind(this);
    this.submitSelected       = this.submitSelected.bind(this);

    this.braintreeInstantiate = this.braintreeInstantiate.bind(this);
    this.addNewSubmit         = this.addNewSubmit.bind(this);
    this.addNewPaypalSubmit   = this.addNewPaypalSubmit.bind(this);
    this.braintreeFailure     = this.braintreeFailure.bind(this);
    this.validAdditonalParams = this.validAdditonalParams.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(clearBraintreeFailure());
  }

  componentDidMount(){
    this.braintreeInstantiate();
  }

  braintreeInstantiate(){
    let { uniqueContainer, font_css, customer } = this.props;
    setupHostedFields( uniqueContainer, font_css, uniqueContainer + "-submit", this.addNewSubmit, this.braintreeFailure )
    setupPaypal( uniqueContainer + "-paypal-container", this.addNewPaypalSubmit, this.braintreeFailure)
    braintreeObjCreate(customer.braintree_token);
  }

  componentWillReceiveProps(nextProps){
    if( this.props.paymentMethods !== nextProps.paymentMethods ){
      if( nextProps.paymentMethods && nextProps.paymentMethods[0] ){
        if(this.state.viewState === 'add') braintreeObjDestroy();
        this.viewSelectedHard();
      } else {
        this.viewSelected();
      }
      this.oSelected = null;
      this.newPayPalObj = null;
    }
  }

  componentWillUnmount(){
    this.notMounted = true;
  }

  addNewPaypalSubmit(obj){
    this.newPayPalObj = obj;
    this.viewSelectedHard();
  }

  validAdditonalParams(){
    if(this.props.additionalParams.amount <= 0){
      this.props.dispatch([
        setFeedback("Payment must be greater then 0."),
        delayedClearFeedback()
      ]);
      return false;
    }
    return true;
  }

  addNewSubmit(obj){
    let { dispatch, customer, additionalParams, submitFunction } = this.props;
    this.setState({ braintreeErrorObj : {} });
    if( this.state.didBrainTreeSubmit === false && this.validAdditonalParams()){
      this.newPayPalObj = null;
      this.setState({
        braintreeErrorObj : null,
        didBrainTreeSubmit: true
      });

      this.oSelected = {};
      if (obj.type === "PayPalAccount") this.oSelected.email = obj.details.email;
      else {
        this.oSelected.cardType = obj.details.cardType;
        this.oSelected.maskedNumber = "**" + obj.details.lastTwo;
      }
      this.viewSelectedHard();

      dispatch( submitFunction(obj, this.braintreeRefresh, additionalParams));
    }
  }

  braintreeFailure(err){
    console.log(err);
    this.setState({ braintreeErrorObj : { message : 'Please fill in all the fields.' } });
  }

  braintreeRefresh(){
    let self = this;
    self.viewAdd();
    self.newPayPalObj = null, self.oSelected = null
    setTimeout( function(){
      if(!self.notMounted) self.setState({ didBrainTreeSubmit : false});
    }, 1000);
  }

  viewSelected(){
    if( !this.props.paymentMethods || !this.props.paymentMethods[0]) this.viewNone();
    else this.setState({ viewState: 'selected'});
  }

  viewNone(){ this.setState({ viewState: 'none'}) }
  viewSelectedHard(){ this.setState({ viewState: 'selected'}) }

  viewAdd(){
    this.setState({ viewState: 'add'});
    let self = this;
    setTimeout( () => self.braintreeInstantiate(), 250);
  }

  selectPaymentMethod(paymentMethodObj){
    this.setState({ viewState: 'selected'});
    this.newPayPalObj = null;
    this.oSelected = paymentMethodObj;
  }

  submitSelected(){
    let { customer, additionalParams, submitFunction, dispatch } = this.props;
    if ( this.state.didBrainTreeSubmit === false  ){
      this.setState({ didBrainTreeSubmit: true });


      dispatch( submitFunction(null, this.oSelected.token, this.braintreeRefresh, additionalParams) );
    }
  }

  render() {
    let oPaymentMethodList           = '',
      elem                           = '',
      oSelectedObj                   = '',
      oPaypalObj                     = '',
      oShowChangePaymentMethodButton = '',
      paymentError                   = '',
      braintreeEmbedElem             = '',
      paymentMethods                 = this.props.paymentMethods,
      braintreeErrors                = this.state.braintreeErrorObj,
      currentView                    = this.state.viewState;

    if(this.oSelected ){
      oSelectedObj = (
        <li className={ this.oSelected.default === true ? "default" : ""}>
          <div className="payment-info"> { this.oSelected.cardType ? this.oSelected.cardType + " ending in " + this.oSelected.maskedNumber.substr(-4,4) : "PayPal " + this.oSelected.email } </div>
        </li>
      );
    }

    if(this.newPayPalObj )
      oPaypalObj = (<li><div className="payment-info"> { "PayPal " + this.newPayPalObj.details.email } </div></li>);

    oShowChangePaymentMethodButton = this.state.didBrainTreeSubmit === true ? '' :
      ( <div className="edit-link" onClick={this.viewAdd}>{ this.props.uniqueContainer && this.props.uniqueContainer.includes("preorder") ? "Edit" : "Change Payment Method" }</div>);
    if(this.props.braintreeFailure && !this.state.didBrainTreeSubmit ) paymentError = (<div className="errorMessage">{this.props.braintreeFailure}</div>);

    if(currentView === "add")
      braintreeEmbedElem = (
          <div className="hostedFieldForm showing" id={this.props.uniqueContainer}>
            {(braintreeErrors && braintreeErrors.message) || (this.props.braintreeFailure && !this.state.didBrainTreeSubmit) ?
              (<p className="errorMessage">{ braintreeErrors && braintreeErrors.message ? braintreeErrors.message : this.props.braintreeFailure }</p>) : ''}

            <label>Credit Card Number</label>
            <div id="card-number" className="hostedFieldInput"></div>

            <label>CVV</label>
            <div id="cvv" className="hostedFieldInput"></div>

            <label>Expiration Date (MM/YYYY)</label>
            <div id="expiration-date" className="hostedFieldInput"></div>

            <label>Zipcode</label>
            <div id="postalCode" className="hostedFieldInput"></div>

            <button className="btn-primary fat full-width showing" id={this.props.uniqueContainer + "-submit"} disabled={true} type="submit">{ this.state.didBrainTreeSubmit === false ? "Checkout" : "Pending..." }</button>
            <div id={this.props.uniqueContainer + "-paypal-container"} className="bt-paypal-button">
              <PayPalButton />
            </div>

            <div className="help-link center" onClick={this.viewNone}> cancel </div>
          </div>
        );
    else if( currentView !== 'none' && (this.oSelected || this.newPayPalObj) ){
      braintreeEmbedElem = (
       <div className="selectedPayment showing">
        { this.newPayPalObj ? oPaypalObj : oSelectedObj }
        {oShowChangePaymentMethodButton}
        <button
          className="btn-primary fat full-width"
          id={ currentView !== 'add' ? this.props.uniqueContainer + "-submit": ""}
          onClick={ this.newPayPalObj ? this.addNewSubmit.bind(this, this.newPayPalObj) : this.submitSelected} >
            { this.state.didBrainTreeSubmit === false ? (this.props.uniqueContainer && this.props.uniqueContainer.includes("one-time") ? "Checkout" : "Place Order" ) : "Pending..." }
        </button>
      </div>
      );
    }

    return (
      <div className="braintreeObj">
          {paymentError}
          {braintreeEmbedElem}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'paymentMethods': state.paymentMethods,
      'braintreeFailure': state.braintreeFailure,
      'font_css': state.store.font_css
    };
}

export default connect(mapStateToProps, null, null, {withRef: true})(NonClubBraintreeDropin);


// WEBPACK FOOTER //
// ./src/components/NonClubBraintreeDropin.jsx